export const SEARCH_EVENTS = {
  PAGELOAD: 'search_page_load',
  AUTOSUGGEST_LOAD: 'search_autosuggest_load',
  AUTOSUGGEST_CLICK: 'search_autosuggest_click',
  SEARCH_INPUT_CLICKED: 'search_input',
};
